export const GOLF_All_ACTION = "GOLF_All_ACTION";
export const GOLF_All_SUCCESS = "GOLF_All_SUCCESS";
export const GOLF_All_FAIL = "GOLF_All_FAIL";

export const GOLF_LIST_ACTION = "GOLF_LIST_ACTION";
export const GOLF_LIST_SUCCESS = "GOLF_LIST_SUCCESS";
export const GOLF_LIST_FAIL = "GOLF_LIST_FAIL"

export const GOLF_DETAIL_ACTION = "GOLF_DETAIL_ACTION";
export const GOLF_DETAIL_SUCCESS = "GOLF_DETAIL_SUCCESS";
export const GOLF_DETAIL_FAIL = "GOLF_DETAIL_FAIL"

export const GOLF_DETAIL_UPDATE_ACTION = "GOLF_DETAIL_UPDATE_ACTION";
export const GOLF_DETAIL_CREATE_ACTION = "GOLF_DETAIL_CREATE_ACTION";
export const GOLF_UPDATE_ORDER_ACTION = "GOLF_UPDATE_ORDER_ACTION";
export const GOLF_FAIL = "GOLF_FAIL";

export const GOLF_CREATE_TRANSLATE_ACTION = "GOLF_CREATE_TRANSLATE_ACTION";
export const GOLF_UPDATE_TRANSLATE_ACTION = "GOLF_UPDATE_TRANSLATE_ACTION";
export const GOLF_DELETE_TRANSLATE_ACTION = "GOLF_DELETE_TRANSLATE_ACTION";

export const RATE_SYNC_ALL_GOLF_ACTION = "RATE_SYNC_ALL_GOLF_ACTION";
export const RATE_SYNC_ALL_GOLF_SUCCESS = "RATE_SYNC_ALL_GOLF_SUCCESS"